
import { defineComponent, inject, onMounted, onUnmounted, ref } from 'vue';
import surveyService from '@/services/survey-service';
import LoadingBar from '@/objects/loading-bar';
import { Survey } from '@/types/survey';
import SocialGraph from '@/components/graph/SocialGraph.vue';
import { ShowToast } from '@/providers/Toast/toast-types';

export default defineComponent({
  name: 'SurveyResults',
  props: {
    surveyId: {
      type: String,
      required: true
    },
    isPublic: {
      type: Boolean
    }
  },
  components: {
    SocialGraph
  },
  setup(props) {
    const survey = ref<Survey | null>(null);
    const loadingBar = new LoadingBar();
    const showToast = inject<ShowToast>('showToast')!;

    const fetchSurvey = () => {
      loadingBar.start();
      if (props.isPublic) {
        surveyService.getShareable(props.surveyId).then((data) => {
          survey.value = data;
          loadingBar.finish();
        });
      } else {
        surveyService
          .get(props.surveyId)
          .then((data) => {
            survey.value = data;
            loadingBar.finish();
          })
          .catch((error) => {
            showToast({
              headline: 'Error',
              message: error.message,
              color: 'danger'
            });
            loadingBar.error();
          });
      }
    };

    onMounted(() => {
      fetchSurvey();
      document.getElementsByClassName('n-layout-content')[0].classList.add('social-graph-page');
    });
    onUnmounted(() => {
      document.getElementsByClassName('n-layout-content')[0].classList.remove('social-graph-page');
    });

    return {
      survey
    };
  }
});
